import { Instagram } from "lucide-react";

const IMAGES = [
  { src: "/gallery/icy-blonde.jpg", caption: "Icy Platinum Waves" },
  { src: "/gallery/bronde-waves.jpg", caption: "Golden Bronde" },
  { src: "/gallery/smoky-brunette.jpg", caption: "Smoky Dimension" },
  { src: "/gallery/violet-curls.jpg", caption: "Violet Velvet Curls" },
  { src: "/gallery/golden-blonde.jpg", caption: "Sunlit Blonde" },
];

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-24 lg:py-36 bg-sand-100"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <div>
            <span className="overline">Recent Work</span>
            <h2 className="mt-6 font-serif font-light text-5xl lg:text-6xl text-ink-900 leading-[1.05] tracking-tight max-w-2xl">
              Straight from<br />
              <span className="italic text-gold">our chairs.</span>
            </h2>
            <p className="mt-6 text-base text-ink-500 max-w-md">
              A few favourites from the team — see everything we&apos;ve
              been up to on Instagram.
            </p>
          </div>
          <a
            href="https://www.instagram.com/flavioshairdesign/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="gallery-instagram-btn"
            className="btn-secondary w-fit"
          >
            <Instagram className="w-4 h-4" />
            @flavioshairdesign
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-3 md:gap-4">
          {IMAGES.map((img, i) => (
            <figure
              key={i}
              data-testid={`gallery-item-${i}`}
              className={`relative group overflow-hidden bg-ink-900 aspect-[4/5] ${
                i === 4 ? "col-span-2 md:col-span-1" : ""
              }`}
            >
              <img
                src={img.src}
                alt={img.caption}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <figcaption className="absolute bottom-3 left-3 bg-sand-50/95 backdrop-blur px-3 py-1.5 text-[0.65rem] tracking-[0.2em] uppercase text-ink-900 translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500 z-10">
                {img.caption}
              </figcaption>
            </figure>
          ))}
        </div>

        <p className="mt-10 text-xs tracking-[0.2em] uppercase text-ink-500 text-center">
          Real guests · Real work · By the Flavio&apos;s team
        </p>
      </div>
    </section>
  );
}
